export default "__VITE_ASSET__Dujpm565__"